const actions = {
    ASM_SALES_DASHBOARD_BEGIN: 'ASM_SALES_DASHBOARD_BEGIN',
    ASM_SALES_DASHBOARD_SUCCESS: 'ASM_SALES_DASHBOARD_SUCCESS',
    ASM_SALES_DASHBOARD_ERR: 'ASM_SALES_DASHBOARD_ERR',

    RANKING_DATA_DATA_BEGIN : 'RANKING_DATA_DATA_BEGIN',
    RANKING_DATA_DATA_SUCCESS: 'RANKING_DATA_DATA_SUCCESS',
    RANKING_DATA_DATA_ERR : 'RANKING_DATA_DATA_ERR',

    getASMSalesDashboardBegin: () => {
        return {
            type: actions.ASM_SALES_DASHBOARD_BEGIN,
        };
    },

    getASMSalesDashboardSuccess: (data) => {
        return {
            type: actions.ASM_SALES_DASHBOARD_SUCCESS,
            data,
        };
    },

    getASMSalesDashboardErr: (err) => {
        return {
            type: actions.ASM_SALES_DASHBOARD_ERR,
            err,
        };
    },
    
 
    getStoreRankingDataBegin: () => {
        return {
            type: actions.RANKING_DATA_DATA_BEGIN,
        };
    },

    getStoreRankingDataSuccess: (data) => {
        return {
            type: actions.RANKING_DATA_DATA_SUCCESS,
            data,
        };
    },

    getStoreRankingDataErr: (err) => {
        return {
            type: actions.RANKING_DATA_DATA_ERR,
            err,
        };
    },

};

export default actions;
